import client from '.spat/modules/client';
// 多言語対応セットアップ
import i18next from 'i18next';

import ja from './plugins/translations/ja';
import en from './plugins/translations/en';
import zh from './plugins/translations/zh';

const resources = { ja, en, zh };
['ja', 'en', 'zh'].forEach(lang => {
  // こういう構造なので translation 配下にネストする
  resources[lang] = {
    translation: resources[lang],
  };
});


i18next.init({
  fallbackLng: 'ja',
  resources,
  lng: global.navigator ? navigator.language.split('-')[0] : 'ja',
}, (err, t) => {
  if (err) {
    throw err;
  }
});

global.i18next = i18next;

global.t = (key, options) => {
  return i18next.t(key, options);
};

// ログインしている場合はトークンをセットする
var token = localStorage.getItem('piguchi_token');
if (token) {
  app.api.setToken(token);
}
// ログインしていない場合
else {
  // TODO: リリース時は消す(開発用にデフォルト token をセット)
  if (spat.config.env !== 'production') {
    token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoib3dseGVPclZicVQ1UTZ3YnpCVFU4QzRnMDFEMyIsImN1c3RvbV9jbGFpbXMiOnt9LCJleHAiOjE5MTAyMTgyMDd9.N7nlZyY4Ake_uQUyQE2X5fsuKPA-H8teWS8VhfM2P9M';
    app.api.setToken(token);
  }
}

client.start();

